import { SLACK_CLIENT_ID } from 'config';

import React, { Component, PropTypes } from 'react';

import { VERIFY_ADD_TO_SLACK_URL } from '../../constants';
import createQuery from '../../utils/createQuery';

import addToSlackOutlineImage from './addToSlackOutline.svg';
import addToSlackImage from './addToSlack.svg';

export default class AddToSlackButton extends Component {
  static propTypes = {
    type: PropTypes.oneOf(['normal', 'outline']),
  }

  static defaultProps = {
    type: 'normal',
  }

  render() {
    const { type, ...rest } = this.props;

    const params = {
      scope: 'commands,chat:write:bot,team:read',
      client_id: SLACK_CLIENT_ID,
      redirect_uri: VERIFY_ADD_TO_SLACK_URL,
    };

    const query = createQuery(params);

    const addToSlackURL = `https://slack.com/oauth/authorize?${query}`;

    return (
      <a href={addToSlackURL}>
        <img
          alt="Add to Slack"
          height="40px"
          src={type === 'outline' ? addToSlackOutlineImage : addToSlackImage}
          {...rest}
        />
      </a>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/AddToSlackButton/index.jsx
 **/